"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CharCodes_1 = require("./enum/CharCodes");

var ParserLocation =
/*#__PURE__*/
function () {
  function ParserLocation() {
    _classCallCheck(this, ParserLocation);

    this.offsets = [0];
    this.template = '';
  }

  _createClass(ParserLocation, [{
    key: "parse",
    value: function parse(template) {
      this.template = template || '';
      var offsets = [0];

      for (var offset = 0; offset < template.length;) {
        switch (this.template.charCodeAt(offset)) {
          case CharCodes_1.default.LineFeed:
            offset += 1;
            offsets.push(offset);
            break;

          case CharCodes_1.default.CarriageReturn:
            offset += 1;

            if (this.template.charCodeAt(offset) === CharCodes_1.default.LineFeed) {
              offset += 1;
            }

            offsets.push(offset);
            break;

          default:
            ++offset;
            break;
        }
      }

      this.offsets = offsets;
    }
  }, {
    key: "findLowerIndexInRangeArray",
    value: function findLowerIndexInRangeArray(value) {
      if (value >= this.offsets[this.offsets.length - 1]) {
        return this.offsets.length - 1;
      }

      var min = 0;
      var max = this.offsets.length - 2;
      var mid;

      while (min < max) {
        mid = min + (max - min >> 1);

        if (value < this.offsets[mid]) {
          max = mid - 1;
        } else if (value >= this.offsets[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break;
        }
      }

      return min;
    }
  }, {
    key: "addLocation",
    value: function addLocation(node) {
      node.loc = {
        start: this.locationForIndex(node.start),
        end: this.locationForIndex(node.end)
      };
    }
  }, {
    key: "locationForIndex",
    value: function locationForIndex(index) {
      if (index < 0 || index >= this.template.length || isNaN(index)) {
        return {
          line: 0,
          column: 0
        };
      }

      var line = this.findLowerIndexInRangeArray(index);
      var column = index - this.offsets[line];
      return {
        line: line + 1,
        column: column + 1
      };
    }
  }]);

  return ParserLocation;
}();

exports.ParserLocation = ParserLocation;